import { fazerLogout } from '../utils/logout';
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/AIAssistant.css';
import '../styles/Dashboard.css';
import Logo from './Logo';
import { getAuthSession } from '../utils/authStorage';

const AIAssistant = () => {
  const [message,   setMessage]   = useState('');
  const [responses, setResponses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const navigate = useNavigate();
  const { customerName } = getAuthSession();
  const clienteNome = customerName || '';

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [responses]);

  const handleSend = async () => {
    if (!message.trim() || isLoading) return;
    const userMsg = message.trim();
    setMessage('');
    setIsLoading(true);

    setResponses(prev => [...prev, { id: Date.now(), user: userMsg, ai: null }]);

    try {
      const { token } = getAuthSession();
      const response = await fetch('/api/ai/chat', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body:    JSON.stringify({ mensagem: userMsg }),
      });
      const data = await response.json();
      setResponses(prev => prev.map((r, i) =>
        i === prev.length - 1 ? { ...r, ai: data.resposta || 'Sem resposta.' } : r
      ));
    } catch {
      setResponses(prev => prev.map((r, i) =>
        i === prev.length - 1 ? { ...r, ai: 'Erro ao conectar com o assistente.' } : r
      ));
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => fazerLogout(navigate);

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <div className="header-left">
          <Logo size="small" onClick={() => navigate('/dashboard')} />
          <div className="header-text">
            <h1>Assistente IA</h1>
            <p className="cliente-info">{clienteNome}</p>
          </div>
        </div>
        <nav className="nav-buttons">
          <button onClick={() => navigate('/dashboard')} className="btn-nav">Dashboard</button>
          <button onClick={handleLogout}                 className="btn-logout">Sair</button>
        </nav>
      </header>

      <div className="dashboard-content">
        <div className="ai-assistant">
          <div className="ai-header">
            <h3>🤖 Assistente ATHACADO 68</h3>
            <p>Tire suas dúvidas sobre pedidos, produtos e muito mais.</p>
          </div>

          <div className="ai-messages">
            {responses.length === 0 && (
              <p style={{ textAlign: 'center', color: '#999', padding: '20px 0' }}>
                Olá! Como posso ajudar você hoje?
              </p>
            )}
            {responses.map(resp => (
              <div key={resp.id} className="message-pair">
                <div className="user-message"><strong>Você:</strong> {resp.user}</div>
                {resp.ai !== null
                  ? <div className="ai-message"><strong>Assistente:</strong> {resp.ai}</div>
                  : <div className="ai-message" style={{ color: '#999' }}>Digitando...</div>
                }
              </div>
            ))}
            <div ref={messagesEndRef} />
          </div>

          <div className="ai-input">
            <input
              type="text"
              value={message}
              onChange={e => setMessage(e.target.value)}
              onKeyPress={e => e.key === 'Enter' && handleSend()}
              placeholder="Digite sua mensagem..."
              disabled={isLoading}
            />
            <button onClick={handleSend} disabled={isLoading || !message.trim()}>
              {isLoading ? '⏳' : '📤'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIAssistant;
